function normalizeInput(value) {
  return String(value || '').trim();
}

/** Detecta URLs de Google Maps (compartir, búsqueda, lugar, goo.gl). */
export function isGoogleMapsUrl(value) {
  const q = normalizeInput(value);
  if (!q) return false;
  if (/^(https?:\/\/)?(www\.)?(google\.[a-z.]+\/maps|maps\.google\.[a-z.]+)/i.test(q)) return true;
  if (/^(https?:\/\/)?(maps\.app\.goo\.gl|goo\.gl\/maps)/i.test(q)) return true;
  return false;
}

function toAbsoluteUrl(value) {
  const q = normalizeInput(value);
  if (!q) return '';
  return q.startsWith('http') ? q : `https://${q}`;
}

/** Texto legible para mostrar (dirección postal; no la URL cruda si es enlace de Maps). */
export function getAddressDisplayLabel(address) {
  const q = normalizeInput(address);
  if (!q) return '';
  if (!isGoogleMapsUrl(q)) return q;

  try {
    const url = new URL(toAbsoluteUrl(q));
    const query = url.searchParams.get('query') || url.searchParams.get('q');
    if (query) return decodeURIComponent(query.replace(/\+/g, ' '));

    const placeMatch = url.pathname.match(/\/maps\/place\/([^/@]+)/);
    if (placeMatch) return decodeURIComponent(placeMatch[1].replace(/\+/g, ' '));
  } catch {
    /* noop */
  }
  return q;
}

/**
 * Enlace universal para abrir Google Maps (PC: pestaña/app; móvil: app o navegador).
 * Acepta dirección en texto o URL de Maps pegada desde «Compartir».
 */
export function buildGoogleMapsSearchUrl(address) {
  const q = normalizeInput(address);
  if (!q) return 'https://www.google.com/maps';
  if (isGoogleMapsUrl(q)) return toAbsoluteUrl(q);
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

/**
 * URL de iframe sin API key (formato clásico output=embed).
 * Si la dirección ya es un enlace de Maps, intenta reutilizarlo para el embed.
 */
export function buildGoogleMapsEmbedUrl(address) {
  const q = normalizeInput(address);
  if (!q) return '';

  if (isGoogleMapsUrl(q)) {
    const absolute = toAbsoluteUrl(q);
    if (absolute.includes('output=embed')) return absolute;
    const sep = absolute.includes('?') ? '&' : '?';
    return `${absolute}${sep}output=embed`;
  }

  return `https://maps.google.com/maps?q=${encodeURIComponent(q)}&hl=es&z=15&ie=UTF8&iwloc=&output=embed`;
}
